/**
 * Navigation links for the header.
 */
export const NAV_LINKS = [
    { label: 'Kahoot Bot', link: '/' },
    { label: 'Name Generator', link: '/names' },
];

/**
 * Navigation links for the footer, organized by category.
 */
export const FOOTER_LINKS = [
  {
    title: 'Product',
    links: [
      { label: 'Kahoot Bot', link: '/' },
      { label: 'Kahoot Name Generator', link: '/names' },
    ]
  },
  {
    title: 'Resources',
    links: [
      { label: 'How it Works', link: '/#how-it-works' },
      { label: 'Features', link: '/#features' },
      { label: 'FAQ', link: '/#faq' },
    ]
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', link: '/privacy' },
      { label: 'Terms of Service', link: '/terms' },
    ]
  }
];